<template>
  <v-expansion-panels focusable>
    <v-expansion-panel v-for="(r, i) in resource.data" :key="'resource-'+i"  style="cursor:pointer;">
      <v-expansion-panel-header>
        <v-row class="pa-0 align-center">
          <v-col cols="6" md="2" :class="`${arabic?'arFont':'enFont'} pa-0 py-1`" PROGRAM v-if="r.program_name">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <v-chip color="secondary" 
                    label x-small style="text-transform:uppercase;" 
                    v-if="r.program_name && r.program_name.slug"
                  >{{r.program_name.slug}}</v-chip>
                  <v-progress-circular indeterminate v-if="!r.program_name || !r.program_name.slug" color="primary"></v-progress-circular>
                </span>
              </template>
              <div class="text-center">
                <div :class="`${arabic?'arFont':'enFont'}`" style="text-transform:uppercase;"
                  v-if="r.program_name && r.program_name.slug"
                >{{r.program_name.slug}}</div>
              </div>
            </v-tooltip>
          </v-col>
          <v-col cols="6" md="5" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 font-weight-bold`" NAME>
            {{r.date.split(' ')[0]}} @ {{r.date.split(' ')[1]}} | <span v-if="r.appointment && r.appointment.number">{{r.appointment.number > 1 ? 'GROUP OF ' + r.appointment.number : 'SINGLE'}} | {{r.appointment.duration}} minutes</span>
          </v-col>
          <v-col cols="6" md="3" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 font-weight-bold`" NAME>
            <div>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span class="pa-0" v-bind="attrs" v-on="on">
                  <v-btn v-if="r.start_url && !r.recording_url" x-small color="primary" class="mx-1" @click.stop="openLink(r.start_url)">START</v-btn>
                  <v-btn v-if="r.join_url && !r.recording_url" x-small color="error" class="mx-1" @click.stop="openLink(r.join_url)">LIVE</v-btn>
                  <v-btn v-if="r.join_url && !r.recording_url" x-small color="success" class="mx-1"
                    v-clipboard:copy="r.join_url"
                    v-clipboard:success="clipboardSuccessHandler"
                    v-clipboard:error="clipboardErrorHandler"
                  >link</v-btn>
                  <v-btn v-if="r.recording_url" x-small color="success" class="mx-1" @click.stop="openLink(r.recording_url)">RECORDING</v-btn>
                  <v-btn v-if="!r.recording_url" x-small color="primary" class="mx-1" @click.stop="generate(r)">GEN & SEND</v-btn>
                  <v-btn v-if="r.start_url && !r.recording_url" x-small color="error" class="mx-1" @click.stop="noShow(r)">NO SHOW</v-btn>
                  <v-btn v-if="r.recording_url" text x-small color="error" class="mx-1" @click.stop="reset(r)">reset</v-btn>
                </span>
              </template>
              <div class="text-center">
                <div :class="`${arabic?'arFont':'enFont'}`">
                  <span v-if="r.created_at">
                  <v-icon size="10">date_range</v-icon>
                  {{r.created_at.split('T')[0]}} |
                  <v-icon size="10">schedule</v-icon>
                  {{r.created_at.split('T')[1].split('.')[0]}}</span>
                </div>
              </div>
            </v-tooltip>
            </div>
            <div v-if="r.zoom_account && r.zoom_account.email" class="text-center" style="font-size:11px">
              {{r.zoom_account.email}}
            </div>
          </v-col>
          <v-col cols="6" md="2" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 adminSwitch text-center`" EDITBUTTON>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">

                <span v-bind="attrs" v-on="on"><span style="font-weight:700;">{{r.candidates.length}}</span>  candidate(s)</span>
              </template>
              <span :class="`${arabic?'arFont':'enFont'} pa-0`">
                <span style="font-weight:700;">{{r.candidates.length}}</span>  candidate(s)
              </span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-divider class="pb-3"></v-divider>
        <candidatesSubAppOnlineListPanel
          :resource="r"
          @present="present"
          @accept="accept"
          @reject="reject"
          :loading="loading"
        />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { format, render, cancel, register } from 'timeago.js';
import candidatesSubAppOnlineListPanel from './candidatesSubAppOnlineListPanel'

export default {
  components: { candidatesSubAppOnlineListPanel },
  props:['resourceSettings', 'resource' , 'resourceKeys', 'match'],
  data() {
    return {
      loading:false,
    }
  },
  methods:{
    reset(r) {
      this.$emit('reset', r)
    },
    noShow(r) {
      this.$emit('noShow', r)
    },
    generate(r) {
      this.$emit('generate', r)
    },
    present(r) {
      this.$emit('present', r)
    },
    accept(r) {
      this.$emit('accept', r)
    },
    reject(r) {
      this.$emit('reject', r)
    },
    openLink(url) {
      window.open(url, '_blank');
    },
    getColor(status) {
      if(status == 'new') {
        return 'success'
      } else
      if(status == 'to_create') {
        return '#9c27b0'
      } else
      if(status == 'confirmed') {
        return 'primary'
      } else
      if(status == 'interview') {
        return '#8bc34a'
      } else
      if(status == 'accepted') {
        return '#00bcd4'
      } else
      if(status == 'need_follow_up' || status == 'out_of_reach') {
        return "#FFC107"
      } else {
        return 'error'
      }
    },
    editSub(r) {
      this.$emit('editSub', r)
    },
    edit(r) {
      this.$emit('editLead', r)
    },
    getFormat(d){
      return format(d)
    },
    clipboardSuccessHandler ({ value, event }){
      this.$emit('copyS', { value, event })
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('copyF', { value, event })
    },
  },
  computed:{
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    user(){
      return this.$store.state.user
    },

  }
}
</script>

<style>

</style>